<template>
  <div class="edrea_tm_section" id="contact">
    <div class="section_inner">
      <div class="edrea_tm_contact">
        <div class="edrea_tm_main_title">
          <h3>Get in <span class="coloring">Touch</span></h3>
        </div>
        <div class="wrapper">
          <div class="left">
            <ul>
              <li>
                <div class="list_inner">
                  <i class="icon-location"></i>
                  <span
                    ><a href="#" class="href_location"
                      >Guatemala City, C.A</a
                    ></span
                  >
                </div>
              </li>
              <li>
                <div class="list_inner">
                  <i class="icon-phone"></i>
                  <span><a href="#">+502 4901 6299</a></span>
                </div>
              </li>
              <li>
                <div class="list_inner">
                  <i class="icon-mail-1"></i>
                  <span
                    ><a href="mailto:hello@devmedialabs.com"
                      >hello@devmedialabs.com</a
                    ></span
                  >
                </div>
              </li>
            </ul>
          </div>
          <div class="right">
            <div class="fields">
              <form
                action="https://cxfsdni7zt6nzsu4kffswp7lz40zkbmd.lambda-url.us-east-1.on.aws/"
                method="post"
                class="contact_form"
                id="contact_form"
              >
                <div class="empty_notice">
                  <span>Please Fill Required Fields</span>
                </div>
                <input v-model="company" name="company" type="text"
                       style="position:absolute;left:-9999px;opacity:0" tabindex="-1" aria-hidden="true" />

                <div class="first">
                  <ul>
                    <li>
                      <div class="list_inner">
                        <input
                          id="name"
                          v-model="name"
                          type="text"
                          placeholder="Name"
                          autocomplete="off"
                        />
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <input
                          id="email"
                          v-model="email"
                          type="text"
                          placeholder="Email"
                          autocomplete="off"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="last">
                  <textarea id="message" v-model="message"  placeholder="Message"></textarea>
                </div>
                <div class="edrea_tm_button">
                  <a id="send_message" href="#" @click="submitForm">{{ loading ? 'Sending…' : 'Send Message' }}</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
  name: `ContactComponent`,
  data() {
    return {
      API_URL:'https://cxfsdni7zt6nzsu4kffswp7lz40zkbmd.lambda-url.us-east-1.on.aws/',
      name: '',
      email: '',
      message: '',
      company: '',
      loading: false,
      startedAt: Date.now(),
      COOLDOWN_MS: 5 * 60 * 1000
    }
  },
  methods: {
    isValidEmail(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(v);
    },
    async submitForm() {
      this.loading = true;

      if (this.company) { 
        toast.success("Your message has been received. We'll contact you soon.", {
          autoClose: 1000,
        });
        return 
      }

      const lastTs = Number(localStorage.getItem('contact_last_ts') || 0);
      const now = Date.now();
      if (now - lastTs < this.COOLDOWN_MS) {
        const left = Math.ceil((this.COOLDOWN_MS - (now - lastTs)) / 60000);
        toast.error(`Please wait about ${left} min before sending again.`, { autoClose: 1500 });
        this.loading = false; return;
      }

      if (!this.name || !this.email || !this.message) {
        toast.error("Please fill all of the fields", {
          autoClose: 1000,
        });
        this.loading = false;
        return
      }

      if (!this.isValidEmail(this.email)) {
        toast.error('Please enter a valid email address', { autoClose: 1200 });
        this.loading = false; return;
      }

      if (now - this.startedAt < 1500) { this.loading = false; return; }


      this.loading = true
      try {
        const resp = await fetch(this.API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: this.name.trim(),
            email: this.email.trim(),
            message: this.message.trim()
          })
        })
        if (!resp.ok) throw new Error(await resp.text())

        toast.success("Your message has been received. We'll contact you soon.", {
          autoClose: 1000,
        }); 

        localStorage.setItem('contact_last_ts', String(now));

        this.name = '';
        this.email = '';
        this.message = '';
        this.startedAt = Date.now();
      } catch (e) {
        console.error(e)
        toast.error("There was a problem sending your message. Please try again.", {
          autoClose: 1000,
        }); 
        
      } finally {
        this.loading = false
      }
    }
  }
 
};
</script>
